<template>
  <div>
      <div class="draw-events">
        <div v-for='draw in $parent.getDrawObjectEvents' :key='draw._id' class="draw-events-flex-parent-container">
          <div class="draw-events-flex-container draw-events-open">
              <div>
                <div class="odds-title">
                  <span class="event-game-title-prefix">{{ draw.eventNumber }}</span>
                  <span class="event-game-title">{{ draw.eventDescription }}</span>
                </div>
                <div class="odds-turnout-prefix">Svenska Folket</div>
                <div class="odds-turnout-prefix">Odds</div>
              </div>
              <div>
              </div>
              <div class="odds-container">
                <div class="odds-turnout">1</div>
                <div class="odds-turnout-value">{{ draw.svenskaFolket.one }}%</div>
                <div class="odds-turnout-value">{{ draw.odds.one }}%</div>
              </div>
              <div class="odds-container">
                <div class="odds-turnout">X</div>
                <div class="odds-turnout-value">{{ draw.svenskaFolket.x }}%</div>
                <div class="odds-turnout-value">{{ draw.odds.x }}%</div>
              </div>
              <div class="odds-container">
                <div class="odds-turnout">2</div>
                <div class="odds-turnout-value">{{ draw.svenskaFolket.two }}%</div>
                <div class="odds-turnout-value">{{ draw.odds.two }}%</div>
              </div>
          </div>
        </div>
      </div>

      <div class="turnover-container">
        Omsättning: {{ $parent.getDrawTurnover }} kr
      </div>

    </div>
</template>

<style>
.odds-title {
  height:19px;
}
.odds-turnout {
  border: 1px solid;
  max-width:22px;
  margin-left:auto;
  margin-right:auto;
}
.odds-turnout-prefix {
  font-size: 10px;
  padding-left:6px;
  padding-top:5px;
}
.odds-turnout-value {
  font-size: 10px;
  padding-top:5px;
}
.odds-container {
  text-align:center;
}
.draw-events-open {

}
</style>
